import { Delete } from "lucide-react";
import { cn } from "@ds/lib/utils";

/**
 * NumPad — keypad angka besar untuk input harga tawar. Tap target ≥ 56px
 * (zona jempol mobile), "Minim ngetik" (rfc-006 §1). Tak menyimpan state —
 * emit event; parent yang mengelola nilai (data layer).
 */
export interface NumPadProps {
  onDigit: (d: string) => void;
  onBackspace: () => void;
  onClear: () => void;
  className?: string;
}

const keys = ["1", "2", "3", "4", "5", "6", "7", "8", "9"];

export function NumPad({ onDigit, onBackspace, onClear, className }: NumPadProps) {
  const keyClass =
    "flex h-14 items-center justify-center rounded-md border border-border bg-surface text-xl font-semibold text-ink tabular-nums transition-colors duration-100 ease-[var(--ease-out-quint)] hover:bg-faint active:bg-faint focus-visible:outline-none";

  return (
    <div
      className={cn("grid grid-cols-3 gap-2", className)}
      role="group"
      aria-label="Papan angka"
    >
      {keys.map((k) => (
        <button key={k} type="button" className={keyClass} onClick={() => onDigit(k)}>
          {k}
        </button>
      ))}
      <button
        type="button"
        className={cn(keyClass, "text-base font-medium text-muted")}
        onClick={onClear}
        aria-label="Hapus semua"
      >
        C
      </button>
      <button type="button" className={keyClass} onClick={() => onDigit("0")}>
        0
      </button>
      <button
        type="button"
        className={cn(keyClass, "text-muted")}
        onClick={onBackspace}
        aria-label="Hapus satu angka"
      >
        <Delete className="size-5" aria-hidden />
      </button>
    </div>
  );
}
